/**
 * sanitize.jsx（XSS対策用ユーティリティ）
 * dangerouslySetInnerHTML に渡す前に、外部入力由来の文字列から
 * HTMLタグを無害化した上で改行・URLの整形を行う
 */
'use strict';

const escapeMap = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

// HTML特殊文字をエスケープする
function escapeHtml(str) {
  if (str == null) return str;
  return String(str).replace(/[&<>"']/g, (c) => escapeMap[c]);
}

// エスケープした上で改行のみ <br /> に変換する
function nl2br(str) {
  if (str == null) return str;
  return escapeHtml(str).replace(/\r\n|\r|\n/g, '<br />');
}

// エスケープ・改行変換した上で URL のみ安全な <a> タグに変換する
const URL_PATTERN = /(\b(?:https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]*[-A-Za-z0-9+&@#/%=~_|])/ig;
function nl2brWithLinks(str) {
  if (str == null) return str;
  return nl2br(str).replace(URL_PATTERN, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
}

const Sanitize = {
  escapeHtml,
  nl2br,
  nl2brWithLinks,
};

module.exports = Sanitize;
